import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Button,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { sendInvoiceApi } from "../../app/slices/partnerInvoice/sendInvoiceSlice";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";

const PdfViewerModal = ({ pdfUrl, open, onClose, _id, paymentStauts }) => {
  const dispatch = useDispatch();

  const handleShowTransection = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to send this invoice via email?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Send",
      cancelButtonText: "Cancel",
      customClass: { popup: "custom-swal-popup" },
      willOpen: () => {
        const popup = document.querySelector(".custom-swal-popup");
        if (popup) {
          popup.style.zIndex = 4000;
        }
      },
    });

    if (result.isConfirmed) {
      // Show loading Swal
      Swal.fire({
        title: "Sending Email...",
        text: "Please wait while the email is being sent.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(); // Show loader
        },
      });

      try {
        const response = await dispatch(sendInvoiceApi({ _id }));
        // console.log("response: of email ", response);

        if (response.meta.requestStatus === "fulfilled") {
          Swal.fire({
            title: "Sent",
            text: "Email sent successfully.",
            icon: "success",
            timer: 3000,
            showConfirmButton: false,
          });

          setTimeout(() => {
            onClose();
          }, 3000);
        } else {
          throw new Error("Failed to send email");
        }
      } catch (error) {
        Swal.fire("Error", "Failed to send the email.", "error");
      }
    } else {
      Swal.fire("Cancelled", "The action was cancelled.", "error");
    }
  };

  return (
    <>
      {/*  */}
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        sx={{ zIndex: 1000, mt: 5 }}
      >
        <DialogTitle>
          Invoice PDF
          <div style={{ position: "absolute", right: 16, top: 8 }}>
            {pdfUrl && (
              <Button
                variant={paymentStauts === "paid" ? "" : "contained"}
                color="primary"
                disabled={paymentStauts === "paid"}
                style={{ marginRight: 8 }}
                onClick={handleShowTransection}
              >
                {paymentStauts === "paid"
                  ? "Invoice Email Already Sent"
                  : "Send Email"}
              </Button>
            )}
            <Tooltip title="Close">
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>
        <DialogContent>
          <iframe
            src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=1`}
            title="PDF Viewer"
            width="100%"
            height="500px"
            style={{ border: "none" }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PdfViewerModal;

// import { Dialog, DialogTitle, DialogContent, IconButton, Button, Tooltip } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import { sendInvoiceApi } from "../../app/slices/partnerInvoice/sendInvoiceSlice";
// import { useDispatch } from "react-redux";
// import Swal from "sweetalert2";  // Import SweetAlert2
//

// const PdfViewerModal = ({ pdfUrl, open, onClose, _id, paymentStauts }) => {
//     const dispatch = useDispatch();

//     const handleShowTransection = async () => {
//         const result = await Swal.fire({
//             title: 'Are you sure?',
//             text: "Do you want to send this invoice via email?",
//             icon: 'warning',
//             showCancelButton: true,
//             confirmButtonText: 'Send',
//             cancelButtonText: 'Cancel',
//             customClass: {
//                 popup: 'custom-swal-popup',
//             },
//             willOpen: () => {
//                 const popup = document.querySelector('.custom-swal-popup');
//                 if (popup) {
//                     popup.style.zIndex = 4000;
//                 }
//             }
//         });

//         if (result.isConfirmed) {
//             const response = await dispatch(sendInvoiceApi({ _id }));
//             console.log("response: of email ", response);
//             if (response.meta.requestStatus === "fulfilled") {
//                 // Swal.fire('Send', 'Email send Successfully .', 'success');
//                 Swal.fire({
//                     title: 'Send',
//                     text: 'Email sent successfully.',
//                     icon: 'success',
//                     timer: 3000, // Auto close after 3 seconds (3000 milliseconds)
//                     showConfirmButton: false // Hide the "OK" button
//                 });

//                 setTimeout(() => {
//                     onClose();
//                 }, 3000);
//             }
//         } else {
//             Swal.fire('Cancelled', 'The action was cancelled.', 'error');
//         }
//     }

//     return (
//         <>
//
//             <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth sx={{ zIndex: 1000, mt: 5 }}>
//                 <DialogTitle>
//                     Invoice PDF
//                     <div style={{ position: "absolute", right: 16, top: 8 }}>
//                         {pdfUrl &&

//                             <Button variant={paymentStauts == "paid" ? "" : "contained"} color={"primary"} disabled={paymentStauts == "paid"} style={{ marginRight: 8 }} onClick={handleShowTransection}>
//                                 {paymentStauts == "paid" ? "Invoice Email Already Send" : "Send Email"}
//                             </Button>
//                         }
//                         <Tooltip title="Close" >
//                             <IconButton onClick={onClose}>
//                                 <CloseIcon />
//                             </IconButton>
//                         </Tooltip>
//                     </div>
//                 </DialogTitle>
//                 <DialogContent>
//                         <iframe
//                             src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=1`}
//                             title="PDF Viewer"
//                             width="100%"
//                             height="500px"
//                             style={{ border: "none" }}
//                         />

//                 </DialogContent>
//             </Dialog>
//         </>
//     );
// };

// export default PdfViewerModal;
